module.exports = __webpack_public_path__ + "static/img/u1.073c7dd9.png";